import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
  },
  submitCommentField: {
    width: "90%",
    padding: "8px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    overflowY: "hidden",
    marginLeft: "4px",
    marginTop: "-20px",
  },
  replyCommentField: {
    width: "90%",
    height: "110px",
    padding: "12px 10px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    // display: "flex",
    alignItems: "center",
    gap: "10px",
    overflowY: "hidden",
    marginLeft: "4px",
    marginTop: "-50px",
  },
  submitButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    marginLeft: "8px",
    minWidth: "44px",
    height: "44px",
  },
  commentHead: {
    display: "flex",
    fontFamily: "poppins",
    justifyContent: "space-between",
    alignItems: "center",
    marginRight: "13px",
    marginBottom: "9px",
  },
  time: {
    color: theme.palette.text.tertiary,
    fontFamily: "poppins",
    fontSize: "14px",
  },
  replyCard: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 15px",
    gap: "15px",
    width: "87%",
    marginLeft: "4px",
    // position: "absolute",
    // marginTop: "-50px",
    backgroundColor: theme.palette.primary.main,
    marginBottom: "6px",
  },
  timeStampDiv: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: theme.palette.primary.main,
    padding: "2px 4px",
    color: "#A8A8A8",
    borderRadius: "4px",
  },
  showHideButton: {
    color: theme.palette.secondary.main,
    paddingLeft: "0px !important",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  colorText: {
    color: theme.palette.secondary.main,
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  showMoreButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "25px",
    width: "150px",
    marginTop: "10px",
    padding: "8px 0px",
    color: theme.palette.secondary.main,
  },
  userName: {
    margin: "0px 8px",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  commentText: {
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
  userName2: {
    margin: "0px 2px",
    fontSize: "14px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "12px !important",
    },
  },
}));

export default useStyles;
